import {SortDirection} from "@renta-apps/athenaeum-toolkit";

export default class ListDeviceAnnualInspectionsRequest {
    public deviceId: string | null = null;
    
    public sortDirection: SortDirection = SortDirection.Asc;
    
    public amount?: number | null = null;
}